import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "twitch",
  "use": "twitch-usage",
  "viewBox": "0 0 256 256",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 256 256\" id=\"twitch\">\n  <g>\n    <path d=\"M45.4375 28L32 62.3304v140.3125h47.7679V228h26.875L132 202.6429h38.8393l52.2321-52.2322V28H45.4375zm159.7321 113.4375l-29.866 29.866h-47.7679l-25.3571 25.3572v-25.3571H61.866V45.9018h143.3035v95.5357zm-29.866-61.2054v52.1875h-17.9018V80.2321h17.9018zm-47.7679 0v52.1875H109.634V80.2321h17.9018z\" fill-rule=\"nonzero\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol